// extracted by mini-css-extract-plugin
module.exports = {"tagBox":"heroV3Styles_tagBox__s_NUs","border-angle-rotate":"heroV3Styles_border-angle-rotate__U_Gks"};